import React from 'react';
import '../../App.css';

const FriendsList = () => {
  return (<div>UNDER CONSTRUCTION</div>)
  return (
    <div id="page-friends" className="page-active">
      <div className="page-header">
        <div className="page-title">Friends & Fans</div>
        <button className="btn-primary" style={{fontSize:'12px', padding:'6px 14px'}}><i className="ti ti-address-book" aria-hidden="true"></i> Import Contacts</button>
      </div>

      <div style={{padding: '16px 24px 0'}}>
        <div style={{display:'flex', gap:'0', background: 'var(--fd-surface2)', borderRadius:'20px', border:'1px solid var(--fd-border)', padding:'3px', width:'fit-content', marginBottom:'16px'}}>
          <div className="vis-opt active">Friends</div>
          <div className="vis-opt">Fans</div>
          <div className="vis-opt">Suggested</div>
          <div className="vis-opt">Find People</div>
        </div>

        <div style={{background:'var(--fd-surface)', border:'1px solid var(--fd-border)', borderRadius:'10px', overflow:'hidden', padding: '4px 16px'}}>
          <div className="friend-row">
            <div className="msg-avatar verified" style={{background: 'linear-gradient(135deg, #2a6496, #1a3d5c)', width:'38px', height:'38px', fontSize:'14px'}}>HH</div>
            <div className="friend-info">
              <div className="friend-name">HoopsHead <span className="fan-badge">Top Fan</span></div>
              <div className="friend-handle">@hoopshead · 84 mutual games</div>
            </div>
            <button className="friend-action following">Friend</button>
          </div>

          <div className="friend-row">
            <div className="msg-avatar" style={{background: 'linear-gradient(135deg, #1a4a7a, #0c2340)', width:'38px', height:'38px', fontSize:'14px'}}>NK</div>
            <div className="friend-info">
              <div className="friend-name">NBAKnows</div>
              <div className="friend-handle">@nbaknows · From contacts</div>
            </div>
            <button className="friend-action add">+ Add</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FriendsList;
